import { render, staticRenderFns } from "./editPersonnel.vue?vue&type=template&id=0b81189a&"
import script from "./editPersonnel.vue?vue&type=script&lang=js&"
export * from "./editPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./editPersonnel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports